import { get, post } from '@/utils/http.js'

//获取设备列表
export const getDeviceList = (data) => post('/devicemanage/findall',data);

//新增设备
export const addDevice = (data) => post('/devicemanage/add',data);

//修改设备
export const editDevice = (data) => post('/devicemanage/updatebyid',data);

//查看设备详情
export const getDevice = (id) => post('/devicemanage/findbyid',{uuid:id});
// 查岗操作
export const guard = (id)=>post('/queryjob/clicknow',id)

// 查岗记录 
export const getrecord=(data)=>post('/queryjob/queryjoblog',data)

//查岗状态 
export const checkStates=(data)=>post('/queryjob/querystate',data)

export const getCheckList=(data)=>post('/queryjob/listbase',data)

export const changeState=(data)=>post('/queryjob/updatestate',data)

export const getAutoList = (data)=>post('/queryjob/querycomdev',data)
export const getDevStatus = (data)=>post('/devicemanage/devicestates',data)